import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = (token) =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${token}` },
  });
